import React from "react";
import { FaUser } from "react-icons/fa";
import { FaHotel } from "react-icons/fa";
import { SiHotelsdotcom } from "react-icons/si";
import { MdTour } from "react-icons/md";

const StatsCard = ({ Data }) => {
  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
        <div className="bg-white rounded-lg p-5 flex items-center gap-x-5">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex justify-center items-center">
            <FaUser className="text-3xl text-[#6ab7ff]" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Total Users</p>
            <p className="text-2xl font-bold">{Data?.totalCustomers || 0}</p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 flex items-center gap-x-5">
          <div className="w-12 h-12 bg-orange-100 rounded-full flex justify-center items-center">
            <FaHotel className="text-3xl text-[#ffa908]" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Total Company</p>
            <p className="text-2xl font-bold">{Data?.totalCompanies || 0}</p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 flex items-center gap-x-5">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex justify-center items-center">
            <SiHotelsdotcom className="text-3xl text-[#04071f]" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Total Hotel</p>
            <p className="text-2xl font-bold">{Data?.totalHotels || 0}</p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 flex items-center gap-x-5">
          <div className="w-12 h-12 bg-green-100 rounded-full flex justify-center items-center">
            <MdTour className="text-3xl text-[#0ba551]" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Total Tours</p>
            <p className="text-2xl font-bold">{Data?.totalTours || 0}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
